export default __webpack_public_path__ + "static/media/proyecto1.06dfe42f.jpg";